module.exports = __webpack_public_path__ + "static/media/icon-blu-128x128.42e81fc0.png";